import { TonConnectButton } from "@tonconnect/ui-react";
import { MARKETING_URL, NETWORK } from "../lib/env";

export function Header() {
  return (
    <header className="header">
      <a className="header__brand" href={MARKETING_URL} aria-label="Back to TONado Cash">
        <img src="/tonadocash.png" alt="" width="34" height="34" />
        <span>
          <em>TON</em>ado<span className="header__brand-cash"> Cash</span>
          <span className="header__brand-mark">·</span>
          <span className="header__brand-app">app</span>
        </span>
      </a>
      <div className="header__meta">
        <span className="header__chain">
          <span className="dot" />
          {NETWORK === "mainnet" ? "TON mainnet" : "TON testnet"}
        </span>
        <TonConnectButton className="header__connect" />
      </div>
    </header>
  );
}
